import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';

import Text from '../Text';

export default function TranslationDisclaimer({ my = '12px' }) {
  const { t } = useTranslation('translationModal');

  return (
    <DisclaimerText variant="small2" fontStyle="italic" as="p" my={my}>
      <Trans i18nKey="translationModal" t={t} components={{ a: <a /> }}>
        {t('translationModal:disclaimer')}
      </Trans>
    </DisclaimerText>
  );
}

// The link used to be told apart from its sentence only by color.
const DisclaimerText = styled(Text)`
  a {
    text-decoration: underline;
  }
`;
